const mutations = {
  setModels(state, data) {
    state.uCurricularCarreras = data.items;
    state.pagination = data._meta;
  },

  setModel(state, data) {
    state.uCurricularCarrera = data;
  },

  addModel(state, model) {
    state.record.nuevo = true;
    state.uCurricularCarreras.unshift(model);
  },

  updateModel(state, model) {
    state.model = model;
    state.record.actualizado = true;
  },

  delModel(state, id) {
    const removeIndex = state.uCurricularCarreras
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.uCurricularCarreras.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};
export default mutations;
